



















































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import editor from '@/components/common/summernote/Index.vue';
import {InquiryAnswerTemplate, PathTemplateNoQueryMallNoRequest, PutInquiryAnswerTemplatesNoRequest, PostInquiryAnswerTemplatesRequest, PutInquiryAnswerTemplatesNoOrderRequest} from 'supporter';

@Component({
  components: {
    editor
  }
})
export default class TemplateSetting extends Vue {
  @Prop() private defaultMallNo: number;
  @Prop({required: true}) private templates!: InquiryAnswerTemplate[];
  @Prop() private mallIndex: number;
  private currTemplateNo: number = 0;
  private currTemplate: InquiryAnswerTemplate = {
    inquiryAnswerTemplateNo: 0,
    inquiryAnswerTemplateContent: '',
    inquiryAnswerTemplateName: '',
    displayOrder: 0
  };
  private isAddBtnClicked: boolean = false;
  private detailRequest: PathTemplateNoQueryMallNoRequest = {
    pathParams: {
      inquiryAnswerTemplateNo: ''
    },
    params: {
      mallNo: 0
    }
  };
  private putRequest: PutInquiryAnswerTemplatesNoRequest = {
    pathParams: {
      inquiryAnswerTemplateNo: ''
    },
    data: {
      inquiryAnswerTemplateContent: '',
      inquiryAnswerTemplateName: '',
      mallNo: 0
    }
  };
  private postRequest: PostInquiryAnswerTemplatesRequest = {
    data: {
      inquiryAnswerTemplateContent: '',
      inquiryAnswerTemplateName: '',
      mallNo: 0
    }
  };
  private orderRequest: PutInquiryAnswerTemplatesNoOrderRequest = {
    pathParams: {
      inquiryAnswerTemplateNo: ''
    },
    data: {
      newOrder: 0,
      mallNo: 0
    }
  };
  private editorContent: string = '';

  private changetedMallNO: number = 0;

  private editorOnChange(content: any): void {
    this.editorContent = content.html;
  }
  private renderData: any = [];
  @Watch('templates')
  onTemplatesData() {
    this.renderData = this.templates;
  }

  private onClickItemOrder(pattern: string) {
    if (this.currTemplateNo === -1) {
      alert(this.$t('MANAGE_INQUIRY_TEMPLATE_SAVE_NEW_ORDER'));
      return;
    }
    let displayOrder = this.currTemplate.displayOrder;
    if (pattern === 'up' && displayOrder > 0) {
      this.orderRequest = {
        pathParams: {
          inquiryAnswerTemplateNo: this.currTemplateNo.toString()
        },
        data: {
          newOrder: this.currTemplate.displayOrder - 1,
          mallNo: this.mallIndex
        }
      };
    }
    if (pattern === 'down' && displayOrder < this.templates.length - 1) {
      this.orderRequest = {
        pathParams: {
          inquiryAnswerTemplateNo: this.currTemplateNo.toString()
        },
        data: {
          newOrder: this.currTemplate.displayOrder + 1,
          mallNo: this.mallIndex
        }
      };
    }
    if (this.orderRequest.pathParams.inquiryAnswerTemplateNo !== '') {
      this.$api.putInquiryAnswerTemplatesNoOrder(this.orderRequest).then((res: any) => {
        if (res.status === 204) {
          this.$emit('search');
          this.currTemplate = this.templates.filter((tlt) => tlt.inquiryAnswerTemplateNo === this.currTemplateNo)[0];
        }
      });
    }
  }

  private async onClickItemAdd() {
    this.isAddBtnClicked = true;
    this.currTemplateNo = -1;
    this.currTemplate = {
      inquiryAnswerTemplateNo: 0,
      inquiryAnswerTemplateContent: '',
      inquiryAnswerTemplateName: '',
      displayOrder: 0
    };
  }

  private onClickItem(templateNo: number) {
    if (this.currTemplateNo === -1) {
      alert(this.$t('MANAGE_INQUIRY_TEMPLATE_SAVE_NEW'));
      return;
    }
    this.currTemplateNo = templateNo;
    this.detailRequest = {
      pathParams: {
        inquiryAnswerTemplateNo: templateNo.toString()
      },
      params: {
        mallNo: this.mallIndex
      }
    };
    this.$api.getInquiryAnswerTemplatesNo(this.detailRequest).then((res) => {
      this.currTemplate = res.data;
    });
  }

  private checkForm() {
    if (!this.currTemplate.inquiryAnswerTemplateName) {
      alert(this.$t('MANAGE_INQUIRY_TEMPLATE_NAME_NODATA'));
      return false;
    }
    if (!this.currTemplate.inquiryAnswerTemplateContent) {
      alert(`${this.currTemplate.inquiryAnswerTemplateName}${this.$t('MANAGE_INQUIRY_TEMPLATE_CONTENT_NODATA')}`);
      return false;
    }
    return true;
  }

  private onClickSaveBtn() {
    this.currTemplate.inquiryAnswerTemplateContent = this.editorContent;
    if (!this.checkForm()) return;
    if (!confirm(`${this.$t('COMMON_SAVE_CONFIRM')}`)) {
      return false;
    }

    if (this.isAddBtnClicked) {
      this.postTemplate();
    } else {
      this.putTemplate();
    }
  }

  private putTemplate() {
    this.putRequest = {
      pathParams: {
        inquiryAnswerTemplateNo: this.currTemplateNo.toString()
      },
      data: {
        inquiryAnswerTemplateContent: this.currTemplate.inquiryAnswerTemplateContent,
        inquiryAnswerTemplateName: this.currTemplate.inquiryAnswerTemplateName,
        mallNo: this.mallIndex
      }
    };
    this.$api.putInquiryAnswerTemplatesNo(this.putRequest).then((res: any) => {
      if (res.status === 204) {
        alert(this.$t('COMMON_SAVE_SUCCESS'));
        this.$emit('search');
      } else {
        alert(this.$t('MANAGE_INQUIRY_TEMPLATE_SAVE_FAIL'));
      }
    });
  }

  private postTemplate() {
    this.postRequest = {
      data: {
        inquiryAnswerTemplateContent: this.currTemplate.inquiryAnswerTemplateContent,
        inquiryAnswerTemplateName: this.currTemplate.inquiryAnswerTemplateName,
        mallNo: this.mallIndex
      }
    };

    this.$api.postInquiryAnswerTemplates(this.postRequest).then((res: any) => {
      if (res.status === 201) {
        alert(this.$t('COMMON_SAVE_SUCCESS'));
        this.$emit('search', (val) => {
          // callback 确保获取到最新的数据
          this.currTemplateNo = val[val.length - 1].inquiryAnswerTemplateNo;
          this.onClickItem(val[val.length - 1].inquiryAnswerTemplateNo);
        });
      } else {
        alert(this.$t('MANAGE_INQUIRY_TEMPLATE_SAVE_FAIL'));
      }
    });
  }

  private deleteTemplate() {
    if (this.currTemplateNo === 0) {
      alert('선택된 답변템플릿이 없습니다.');
      return false;
    }
    if (!confirm('답변템플릿을 삭제하시겠습니까?')) {
      return false;
    }
    if (this.currTemplateNo === -1) {
      this.isAddBtnClicked = false;
      this.currTemplateNo = this.templates[this.templates.length - 1].inquiryAnswerTemplateNo;
      this.onClickItem(this.templates[this.templates.length - 1].inquiryAnswerTemplateNo);
    } else {
      this.detailRequest = {
        pathParams: {
          inquiryAnswerTemplateNo: this.currTemplateNo.toString()
        },
        params: {
          mallNo: this.mallIndex
        }
      };
      this.$api.deleteInquiryAnswerTemplatesNo(this.detailRequest).then(() => {
        this.$emit('search', (val) => {
          // callback 确保获取到最新的数据
          if (val.length === 0) {
            this.displayStatus = false;
          } else {
            this.currTemplateNo = val[0].inquiryAnswerTemplateNo;
            this.onClickItem(val[0].inquiryAnswerTemplateNo);
          }
        });
      });
    }
  }
  private displayStatus: boolean = false;
  @Watch('templates')
  onTemplateChanged(newVal: InquiryAnswerTemplate[], oldVal: InquiryAnswerTemplate[]) {
    if (this.templates.length) {
      this.displayStatus = true;
    } else {
      this.displayStatus = false;
    }

    if (oldVal.length === 0 && newVal.length > 0) {
      this.onClickItem(newVal[0].inquiryAnswerTemplateNo);
    }
    if (this.isAddBtnClicked) {
      this.onClickItem(newVal[newVal.length - 1].inquiryAnswerTemplateNo);
      this.isAddBtnClicked = false;
    }
  }
  @Watch('isAddBtnClicked')
  onIsAddBtnClicked(data: any) {
    if (data) {
      this.displayStatus = true;
    }
  }
}
